import React, { useEffect } from "react";
import { validateNew } from "../../app/validations/UserFormValidationRules";
import useFormUser from "../../app/hooks/useFormUser";
import { useDispatch, useSelector } from "react-redux";
import Swal from "sweetalert2";
import { useTranslation } from "react-i18next";

import CheckListComponent from "./CheckListComponent";
import { startLoadingCatalogRoles } from "../../app/actions/catalogRoleActions";
import ListUserComponent from "./ListUserComponent";
import NavbarIconsUserRole from "../generic-nav-bar/NavbarIconsUserRole";
import { userCleanUserInUserRole } from "../../app/actions/userActions";
import { startLoadingCatalogModules } from "../../app/actions/catalogModuleActions";

const AdminUserRoleScreen = () => {
  const dispatch = useDispatch();
  const { userSelected } = useSelector((state) => state.user);
  const { catalogRoles } = useSelector((state) => state.catalogRole);

  const { t } = useTranslation();

  const { values, handleSubmit } = useFormUser(() => userCallback(), validateNew, userSelected);

  const userCallback = () => {
    values.blocked = false;
    Swal.fire("success", "User save succesfull", "success");
  };

  useEffect(() => {
    dispatch(userCleanUserInUserRole());
    dispatch(startLoadingCatalogRoles());
    dispatch(startLoadingCatalogModules());
  }, []);

  const addColumnValueToArray = (listCatalogRoles) => {
    const catalogRolesList = [];

    listCatalogRoles.forEach((element) => {
      if (element.name !== "Registered" && element.name !== "Guest") {
        catalogRolesList.push({
          ...element,
          value: false,
        });
      }
    });

    return catalogRolesList;
  };

  const roleData = catalogRoles?.length > 0 ? addColumnValueToArray(catalogRoles) : [];

  return (
    <div>
      <NavbarIconsUserRole />
      <div className="d-flex justify-content-center page-title">{t("admin.user_roles.register")}</div>

      <div className="section is-fullheight">
        <div className="container">
          <form onSubmit={handleSubmit} noValidate>
            {roleData.length > 0 ? (
              <CheckListComponent.Provider data={roleData}>
                <div className="row">
                  <div className="col-md-6">
                    <label className="form-label" style={{ fontWeight: "bold" }}>
                      {t("admin.user_roles.user_list")}
                    </label>
                    <ListUserComponent />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label" style={{ fontWeight: "bold" }}>
                      {t("admin.user_roles.role_list")}
                    </label>
                    <div className="control">
                      <CheckListComponent.RolesList />
                    </div>
                  </div>
                </div>
                <CheckListComponent.ModulePanelsRow />
              </CheckListComponent.Provider>
            ) : null}
          </form>
        </div>
      </div>
    </div>
  );
};

export default AdminUserRoleScreen;
